import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const RoleBaseUrl = '/admin/role'

export async function queryRole(params) {
  const result = await request({
    url: RoleBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query role failed!') ?? []
}

export async function createRole(data) {
  const result = await request({
    url: RoleBaseUrl,
    method: 'POST',
    data
  })
  return ResultHandler(result, 'Create role failed!') ?? []
}

export async function updateRole(data) {
  const result = await request({
    url: RoleBaseUrl,
    method: 'PUT',
    data
  })
  return ResultHandler(result, 'Update role failed!') ?? []
}
export async function removeRole(id) {
  const result = await request({
    url: RoleBaseUrl,
    method: 'DELETE',
    params: { id }
  })
  return ResultHandler(result, 'Update role failed!') ?? []
}
